var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav_box"},[_c('el-menu',{staticClass:"el-menu-demo",attrs:{"default-active":"1","mode":"horizontal","active-text-color":"#1868ca"},on:{"select":_vm.handleSelect}},_vm._l((_vm.navList),function(navItem,navIndex){return _c('el-menu-item',{key:navIndex,attrs:{"index":navItem.num}},[_vm._v(_vm._s(navItem.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }